module.exports = __webpack_public_path__ + "static/media/globaltempapi.98c17a69.png";